var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'מצאנו עוד חשבון בנק!',"text":'לדיוק התזרים, נצטרך לדעת האם להשאיר אותו כחלק מהתזרים או להתעלם ממנו.',"notification-buttons":[
                      {
                        title:'לדיוק התזרים',
                        variant: 'primary',
                        size: 'slim',
                        action: _vm.openInvestigation,
                      } ],"icon-type":'warning'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }